import { EVENT, EVENT_TYPE } from 'features/common/gtm/constants';
import { useDataLayer } from 'features/common/gtm/hooks';

export const useSortColumnsDataLayer = () => {
	const handleDataLayer = useDataLayer({ event: EVENT.sortColumns, eventType: EVENT_TYPE.sortType });
	return handleDataLayer;
};
